// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"289a02c8","154":"3a34b816","912":"289a02c8"}[chunkId] + ".chunk.css";
};